import ABCyaPhaser from "@abcya/abcya_phaser";

export default class SoundChain {
    constructor(scene, soundNames) {
        this.scene = scene;

        this.soundNames = soundNames;
        this.soundCounter = 0;
        this.enabled = true;
        this.sound = ABCyaPhaser.Audio.createSound(scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.sound.destroy());
        this.sound.on(Phaser.Sound.Events.COMPLETE, this.play, this);
    }

    play() {
        if (!this.enabled) {
            return;
        }

        let name = this.soundNames[this.soundCounter];
        if (name == null) return;
        this.soundCounter++;
        ABCyaPhaser.Audio.playSound(name, this.sound);
    }

    stop() {
        this.enabled = false;
        this.sound.stop();
    }
}
